module.exports = __webpack_public_path__ + "0581e5b33e19a1702ca96ef824dc94d2.jpg";